import * as SPINNER from '../helpers/spinner';

$('#invoice-form').on('submit', function (e) {
    e.preventDefault();
    sendInvoiceRequest();
});

function sendInvoiceRequest(csrfToken)
{
    if (typeof csrfToken === 'undefined') {
        $('#invoice-form').find('input[name="_token"]').val(csrfToken);
    } else {
        csrfToken = $('meta[name="csrf-token"]').attr('content');
    }

    SPINNER.showSpinner();
    removeErrors();
    $.ajax({
        url: "/ajax/invoice/new-request",
        type: 'POST',
        dataType: "JSON",
        headers: {
            'X-CSRF-TOKEN': csrfToken
        },
        data: new FormData(document.getElementById('invoice-form')),
        processData: false,
        contentType: false,
    }).then(function (response) {
        if (response.success) {
            location.reload();
            $(window).scrollTop(0);
        } else {
            showErrors(response.errors, '#invoice-form', 'invoice_');
            // jumpToTop(Object.keys(response.errors)[0], 'invoice_');
        }
        SPINNER.hideSpinner();
    }).fail(function (data) {
        const errors = data?.responseJSON?.errors || [];

        if (typeof data.status !== 'undefined' && data.status === 419) {
            window.refreshCsrfToken()
                .then((response) => {
                        $('meta[name="csrf-token"]').attr('content', response.data);
                        sendInvoiceRequest(response.data);
                    }
                );
        } else {
            showErrors(errors, '#invoice-form', 'invoice_');
        }
        
        // jumpToTop(Object.keys(errors)[0], 'invoice_');
        SPINNER.hideSpinner();
    });
}

function showErrors(errors, form, prefix)
{
    if (errors === undefined || errors === null) {
        console.log('showErrors: Errors are not defined');
        return;
    }

    for (let [key, message] of Object.entries(errors)) {
        key = key.replace('.', '_');
        key = key.replace('other_fields_', '');
        const error_html = "<div class='text-danger field-error small'>" + message + "</div>"
        $(form + ' #' + prefix + key).after(error_html);
    }
}

function removeErrors()
{
    $('.field-error').remove();
}

function jumpToTop(id, prefix)
{
    document.getElementById(prefix + id).parentElement.scrollIntoView(true);
}
